<template>
    <div class="mx-10">
      <v-tabs v-model="activeTab" color="#00B3FF">
        <v-tab >Customer Info</v-tab>
        <v-tab >Customer Account</v-tab>
        <v-tab >Customer Invoices</v-tab>
        <v-tab >Customer Payments</v-tab>
        <v-tab >Purchase Returns</v-tab>
        <v-tab >Customer Notes</v-tab>

        <v-tab-item>
          <CustomerInfo/>
        </v-tab-item>
        <v-tab-item>
          <CustomerAccount/>
        </v-tab-item>
        <v-tab-item>
          <CustomerInvoices/>
        </v-tab-item>
        <v-tab-item>
          <CustomerPayments/>
        </v-tab-item>
        <v-tab-item>
          <PurchaseReturns/>
        </v-tab-item>
        <v-tab-item>
          <CustomerNotes/>
        </v-tab-item>

      </v-tabs>
    </div>
  </template>
  
  <script>
  
 
  const { mapGetters } = createNamespacedHelpers("auth");
  import { createNamespacedHelpers } from "vuex";

  import CustomerInfo from "./CustomerInfo.vue";
  import CustomerAccount from "./CustomerAccount.vue";
  import CustomerInvoices from "./CustomerInvoices.vue";
  import CustomerPayments from "./CustomerPayments.vue";
  import CustomerNotes from "./CustomerNotes.vue";
  import PurchaseReturns from "./CustomerReturns.vue";
   
  
  export default {
    name: "Setting",
    components: {
     
      
      CustomerInfo,
      CustomerAccount,
      CustomerInvoices,
      CustomerPayments,
      CustomerNotes,
      PurchaseReturns

    },
    data() {
      return {
        activeTab: 0,
      };
    },
    computed: {
      ...mapGetters({
        loading: "loading",
        profile: "profile",
        hasPermission: "hasPermission",
      }),
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
    },
  };
  </script>
  